// src/constants.js
export const BOARD_CONFIG = {
  MIN_WIDTH: 250,
  MAX_WIDTH: 500,
  DEFAULT_WIDTH: 250,
  COUNT: 13
};

export const SPRINT_CONFIG = {
  START_SPRINT: 88,
  BASE_DATE: '2024-07-01',
  SPRINT_LENGTH: 14
};

export const COLORS = {
  PRIMARY: '#205D5E',
  SECONDARY: '#00B087',
  BACKGROUND: '#F6D8DA',
  WHITE: '#FFFFFF'
};

export const STATUS_CLASSES = {
  DONE: 'status-done',
  'IN PROGRESS': 'status-in-progress',
  BLOCKED: 'status-blocked',
  'TO DO': 'status-todo',
  TODO: 'status-todo',
  REVIEW: 'status-review',
  'SELECTED FOR DEVELOPMENT': 'status-selected-for-development',
  'WAITING FOR REVIEW': 'status-waiting-for-review',
  REJECTED: 'status-rejected',
  CANCELED: 'status-canceled',
  NEW: 'status-new'
};

export const PRIORITY_CLASSES = {
  HIGH: 'priority-high',
  MEDIUM: 'priority-medium',
  LOW: 'priority-low'
};